module.exports = __webpack_public_path__ + "img/EWMA-District-Logo-Transparent@3x.8b8e8a6f.webp";